var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('Menu'),_c('Banner'),_c('AboutUs'),_c('Mission'),_c('Products'),_c('Benefits'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }